export default "__VITE_ASSET__07b5d259__"